module.exports = __webpack_public_path__ + "static/media/instagram.0dc59a18.svg";